document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kg-tcats]').forEach(function (section) {
    var el = section.querySelector('[data-kg-tcats-swiper]');
    if (!el || typeof Swiper === 'undefined') return;

    var prev = section.querySelector('.kg-tcats__nav-btn--prev');
    var next = section.querySelector('.kg-tcats__nav-btn--next');

    new Swiper(el, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 12,
      roundLengths: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: prev,
        nextEl: next
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1
        },
        1200: {
          slidesPerView: 3,
          slidesPerGroup: 1
        },
        1600: {
          slidesPerView: 4,
          slidesPerGroup: 1
        }
      }
    });
  });
});
